import App from '@modules/husleie-framework/src/static-classes/App.class';
import StringOperations from '@modules/husleie-framework/src/static-classes/StringOperations.class';
import { micromark } from 'micromark';
import { gfm, gfmHtml } from 'micromark-extension-gfm';
import { gfmTaskListItem, gfmTaskListItemHtml } from 'micromark-extension-gfm-task-list-item';
import { gfmStrikethrough, gfmStrikethroughHtml } from 'micromark-extension-gfm-strikethrough';
import sanitizeHtml from 'sanitize-html';
import Vue from 'vue';
import { TranslateResult, Values } from 'vue-i18n';
import { mapGetters } from 'vuex';
import I18nOperations from '../utils/I18nOperations.class';

const markdownSpecifier = 'md-';

export default Vue.extend({
  computed: {
    ...mapGetters('common/features', ['getFeature']),

    platformName(): string {
      return this.getFeature('application.platform.name');
    },
    translationsPrefix(): string {
      return App.getTranslationsDefaultProject() || '';
    },
    optionalIndicator(): string {
      return this.translate('label.indicator.optional');
    },
    locale(): string {
      return this.$i18n.locale;
    },
  },
  methods: {
    translate(term: string, values?: Values): string {
      let data = String(this.$i18n.t(`${App.getTranslationsDefaultProject()}.${term}`, values));

      // Return empty string
      if (data === '.' || data.toLowerCase() === '<empty>') {
        data = '';
        return data;
      }

      // Determine if the string contains markdown prefix.
      const termLastPart: string = term.split('.').pop()!;
      const isMarkDown = termLastPart.startsWith(markdownSpecifier);

      // Return default string - without converting to markdown
      if (!isMarkDown) {
        return data.replaceAll('  \n', '<br>');
      }

      // If translated string includes markdownspecifier, the translation service is not working/not existing.
      // make sure we return a value without the prefix.
      if (data.startsWith(markdownSpecifier)) {
        data = data.substring(markdownSpecifier.length);
        // Since we also do this in workspaces/modules/husleie-framework/src/i18n/i18n.js,
        // i am unsure if its needed. Until traced, this should remain.
        data = data.replaceAll('{dot}', '.');
      }

      return sanitizeHtml(
        micromark(data, {
          extensions: [gfm(), gfmStrikethrough(), gfmTaskListItem],
          htmlExtensions: [gfmHtml(), gfmTaskListItemHtml, gfmStrikethroughHtml],
        }),
        {
          allowedTags: sanitizeHtml.defaults.allowedTags.concat(['input', 'del']),
          allowedAttributes: { input: ['disabled', 'checked', 'type'], a: ['href'] },
        }
      );
    },
    translatePlural(term: string, choice: any, values?: Values) {
      return this.$i18n.tc(`${this.translationsPrefix}.${term}`, choice, values);
    },
    capitalizeFirst(data: TranslateResult) {
      return StringOperations.capitalizeFirst(data);
    },
    capitalizeAll(data: TranslateResult) {
      return StringOperations.capitalizeAll(data);
    },
    toCurrency(currency: any, value: any) {
      const currencyLocale = this.$i18n.locale.replace('_', '-');
      return I18nOperations.toCurrency(currencyLocale, currency, value);
    },
  },
});
